import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export interface HFClearAllProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    children: string
    childtestid: string
    clearAllFilters: () => void
}

const HFClearAll = memo(({templating, children, childtestid, clearAllFilters}: HFClearAllProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)
    return (
        <Suspense>
            <ComponentName childtestid={childtestid} clearAllFilters={clearAllFilters}>
                {children}
            </ComponentName>
        </Suspense>
    )
})
HFClearAll.displayName = "HFClearAll"

export default connect(HFClearAll)
